import classNames from "classnames"
import { INDICATOR_DEFAULT_CLASSNAME, INDICATOR_CLASSNAME_BY_SIZE } from "./constants"
import { AvatarIndicatorProps } from "./types"

const Indicator = ({ size = "xs", className, status }: AvatarIndicatorProps) => {
  const isOnline = status === "online"
  return (
    <span
      className={classNames(
        INDICATOR_DEFAULT_CLASSNAME,
        INDICATOR_CLASSNAME_BY_SIZE[size],
        {
          "bg-success-lighten-50": isOnline,
          "bg-gray-400": !isOnline,
        },
        className,
      )}
    />
  )
}

export const AvatarIndicator = ({ size = "xs", status = "offline" }: AvatarIndicatorProps) => {
  const isOnline = status === "online"
  return (
    <>
      <Indicator status={status} size={size} />
      {isOnline && <Indicator status={status} size={size} className="group-hover:animate-ping" />}
    </>
  )
}
